import type { ReactNode } from 'react'

import type { WizardFlow } from '@klear/ui/wizard/flow'
import { WizardNavRow, type WizardNavRowProps } from '@klear/ui/wizard/nav-row'

export type WizardFlowContentProps = {
  flow: WizardFlow
  showNav?: boolean
  children?: ReactNode
  className?: string
} & Pick<
  WizardNavRowProps,
  | 'onSubmit'
  | 'cancelOnFirstStep'
  | 'disabled'
  | 'nextDisabled'
  | 'submitDisabled'
  | 'nextLabel'
  | 'nextIcon'
  | 'submitLabel'
  | 'submitIcon'
  | 'prevLabel'
> & {
    navClassName?: string
  }

export function WizardFlowContent({
  flow,
  showNav = true,
  children,
  className = 'mx-auto w-full max-w-2xl space-y-4',
  onSubmit,
  cancelOnFirstStep,
  disabled,
  nextDisabled,
  submitDisabled,
  nextLabel,
  nextIcon,
  submitLabel,
  submitIcon,
  prevLabel,
  navClassName
}: WizardFlowContentProps) {
  const resolvedNextDisabled = (nextDisabled ?? !flow.canNext) || flow.isAdvancing
  const resolvedDisabled = disabled === true || flow.isAdvancing
  const resolvedNextLabel = flow.isAdvancing ? 'Validating…' : (nextLabel ?? 'Next')

  return (
    <div className={className}>
      {children}
      {flow.content}
      {showNav ? (
        <WizardNavRow
          isFirstStep={flow.isFirstStep}
          isLastStep={flow.isLastStep}
          onPrev={flow.goPrev}
          onNext={() => {
            void flow.goNext()
          }}
          onSubmit={onSubmit}
          cancelOnFirstStep={cancelOnFirstStep}
          disabled={resolvedDisabled}
          nextDisabled={resolvedNextDisabled}
          submitDisabled={submitDisabled}
          nextLabel={resolvedNextLabel}
          nextIcon={nextIcon}
          submitLabel={submitLabel}
          submitIcon={submitIcon}
          prevLabel={prevLabel}
          className={navClassName}
        />
      ) : null}
    </div>
  )
}
